<template>
  <div id="home">
    <div class="banner">
      <img src="../../assets/solve/jj_banner.png" alt />
      <div class="divs">
        <p>私域流量异军突起，99%的企业选择用小程序 打造自己的品牌私域流量</p>
      </div>
    </div>
    <div class="content">
      <div class="content_one1_solve"  id="10">
        <div class="content_one-con1">
          <p class="one-p">今云为您提供的服务</p>
          <ul class="one_li1">
            <li>
              <img src="../../assets/solve/jj-a_icon_01.png" alt />
              <p>技术服务</p>
            </li>
            <li>
              <img src="../../assets/solve/jj-a_icon_02.png" alt />
              <p>代运营服务</p>
            </li>
            <li>
              <img src="../../assets/solve/jj-a_icon_03.png" alt />
              <p>专业文案</p>
            </li>
            <li>
              <img src="../../assets/solve/jj-a_icon_04.png" alt />
              <p>专属设计</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="content_two_solve" id="11">
        <img src="../../assets/solve/jj_bg.png" alt class="imss" />
        <div class="content_two-con_solve">
          <p class="two-p">今云AI拓客系统功能介绍及价格</p>
          <p class="two-p1">系统平台会不断升级，新增功能不会额外收费（定制插件除外）</p>
          <div class="two_botom">
            <img src="../../assets/solve/jj_bg_01.png" alt />
            <div class="two_botoms">
              <div class="two_botom_cent">
                <ul class="two_botom_li">
                  <li>
                    <p>自定义内容</p>
                    <p>可自定义页面板块、内容、位置等</p>
                  </li>

                  <li>
                    <p>官网展示</p>
                    <p>可展示文章、图片、视频、语音、表单等</p>
                  </li>

                  <li style="border:0">
                    <p>新闻动态</p>
                    <p>可展示视频、文章、文字、图片等</p>
                  </li>
                </ul>
                <ul class="two_botom_li">
                  <li>
                    <p>特产商城</p>
                    <p>可选择是否开启，强大的分销商城</p>
                  </li>

                  <li>
                    <p>AI名片</p>
                    <p>对外名片及信息展示，可在微信发名片</p>
                  </li>

                  <li style="border:0">
                    <p>在线IM</p>
                    <p>可在线进行招商咨询沟通</p>
                  </li>
                </ul>
                <ul class="two_botom_li" style="border-bottom: 1px solid rgba(225, 230, 240, 1);">
                  <li>
                    <p>数据分析</p>
                    <p>工作人员在线查看数据，解答咨询</p>
                  </li>

                  <li>
                    <p>AI雷达</p>
                    <p>可分析客户行为、兴趣、意向，智能捕捉客户</p>
                  </li>

                  <li style="border:0">
                    <p>更多</p>
                    <p>AI文章、AI海报、商城分销等30余功能</p>
                  </li>
                </ul>
                <div class="two_botom_mony">
                  <div class="two_botom_mony_left">
                    <img src="../../assets/solve/jj_icon_wx.png" alt />
                    <img src="../../assets/solve/jj_icon_wx5800.png" alt style="margin-right:8px" />
                    <p>元/年</p>
                  </div>
                  <div class="two_botom_mony_on">
                    <img src="../../assets/solve/jj_icon_qw.png" alt />
                    <img src="../../assets/solve/jj_icon_qw9800.png" alt style="margin-right:8px" />
                    <p>元/年</p>
                    <p>包含：微信、抖音、头条</p>
                  </div>
                  <!-- <div class="two_botom_mony_right">
                    <p>申请使用</p>
                  </div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content_three_solve" id="12">
        <div class="content_three-con">
          <p class="one-p">简单五步，开启合作</p>
          <ul class="three_li">
            <li>
              <img src="../../assets/solve/jj-c_icon_01.png" alt />
              <p>签署服务合同</p>
            </li>
            <li>
              <img src="../../assets/solve/jj-c_icon_06.png" alt />
            </li>
            <li>
              <img src="../../assets/solve/jj-c_icon_02.png" alt />
              <p>支付首年费用</p>
            </li>
            <li>
              <img src="../../assets/solve/jj-c_icon_06.png" alt />
            </li>
            <li>
              <img src="../../assets/solve/jj-c_icon_03.png" alt />
              <p>申请小程序账号</p>
            </li>
            <li>
              <img src="../../assets/solve/jj-c_icon_06.png" alt />
            </li>
            <li>
              <img src="../../assets/solve/jj-c_icon_04.png" alt />
              <p>接入代码 上传审核</p>
            </li>
            <li>
              <img src="../../assets/solve/jj-c_icon_06.png" alt />
            </li>
            <li>
              <img src="../../assets/solve/jj-c_icon_05.png" alt />
              <p>维护内容、运营</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    this.$emit("footer", true); //是否显示头部
    return {};
  },
  methods: {
    apply() {},
    home() {
      this.$router.push({
        path: "/"
      });
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  list-style: none;
}

#home {
  width: 100%;
  position: relative;
}

.top {
  width: 100%;
  background: #2b2f33;
  position: fixed;
  z-index: 99;
}

.top_one {
  width: 1200px;
  margin: 0 auto;
}

.img {
  width: 200px;
  height: 40px;
  padding: 10px 57px 15px 0;
  float: left;
}

.top_li li {
  float: left;
  line-height: 65px;
  color: #fff;
  margin-right: 43px;
  cursor: pointer;
}

.top_li li:hover {
  color: #337eff;
}

.top_right {
  float: right;
  line-height: 65px;
}

.button {
  width: 90px;
  height: 33px;
  line-height: 0;
  padding: 0;
}

.bottons {
  background-color: transparent;
  color: #409eff;
  border: 1px solid #409eff;
}

.bottons:hover {
  background-color: #409eff;
}

.add {
  margin-left: 5px;
}

.banner {
  width: 100%;
  height: 400px;
  position: relative;
}

.banner img {
  width: 100%;
  height: 400px;
}

.divs {
  width: 100%;
  height: 102px;
  position: absolute;
  top: 148px;
}

.divs p {
  width: 750px;
  height: 102px;
  text-align: center;
  font-size: 46px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 58px;
  margin: 0 auto;
}

.content {
  width: 100%;
}

.content_one1_solve {
  width: 100%;
  height: 500px;
}

.content_one-con1 {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.one-p {
  font-size: 34px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 101px 0 78px 0;
  text-align: center;
}

.two-p {
  font-size: 34px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 101px 0 20px 0;
  text-align: center;
}

.two-p1 {
  font-size: 16px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
  margin: 0 0 20px 0;
  text-align: center;
}

.one_li1 {
  width: 1002px;
  margin: 0 auto;
}

.one_li1 li {
  width: 140px;
  text-align: center;
  float: left;
}

.one_li1 li:nth-child(2) {
  margin-left: 137px;
}

.one_li1 li:nth-child(3) {
  margin-left: 148px;
}

.one_li1 li:nth-child(4) {
  margin-left: 157px;
}

.one_li1 p {
  font-size: 20px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  font-family: Source Han Sans CN;
  margin-left: 20px;
}

.content_two_solve {
  width: 100%;
  height: 954px;
  position: relative;
}

.imss {
  width: 100%;
  height: 954px;
  position: absolute;
  z-index: -1;
}

.content_two-con_solve {
  width: 1200px;
  margin: 0 auto;
  overflow: hidden;
}

.two_botoms {
  width: 1080px;
  height: 464px;
  background: #fff;
  margin: 0 auto;
}

.two_botom_cent {
  width: 958px;
  margin: 0 auto;
  overflow: hidden;
}

.two_botom_li {
  width: 100%;
  height: 100px;
  border-bottom: 1px dashed rgba(225, 230, 240, 1);
  overflow: hidden;
  margin-top: 10px;
}

.two_botom_li li {
  width: 288px;
  height: 73px;
  border-right: 1px dashed rgba(225, 230, 240, 1);
  float: left;
  margin: 10px 0 0 30px;
}

.two_botom_li li p:first-child {
  font-size: 20px;
  font-weight: 600;
  color: rgba(51, 51, 51, 1);
  margin: 15px 0 10px 0;
}

.two_botom_li li p:last-child {
  font-size: 14px;
  font-weight: 400;
  color: rgba(159, 161, 159, 1);
}

.two_botom_mony {
  width: 100%;
  height: 122px;
  overflow: hidden;
}

.two_botom_mony_left {
  width: 250px;
  margin-top: 46px;
  float: left;
}

.two_botom_mony_left img {
  float: left;
  margin-right: 18px;
}

.two_botom_mony_left p {
  color: rgba(159, 161, 159, 1);
  line-height: 37px;
}

.two_botom_mony_on {
  width: 500px;
  float: left;
  margin-top: 46px;
}

.two_botom_mony_on img {
  float: left;
  margin-right: 18px;
}

.two_botom_mony_on p {
  color: rgba(159, 161, 159, 1);
  line-height: 37px;
  float: left;
  margin-right: 9px;
}

.two_botom_mony_right {
  width: 160px;
  height: 42px;
  background: rgba(50, 122, 245, 1);
  border-radius: 4px;
  float: right;
  margin-top: 40px;
  text-align: center;
  cursor: pointer;
}

.two_botom_mony_right p {
  line-height: 42px;
  color: #fff;
}

.content_three_solve {
  width: 100%;
}

.content_three-con {
  width: 1200px;
  height: 477px;
  margin: 0 auto;
}

.three_li {
  width: 100%;
}

.three_li li {
  width: 174px;
  text-align: center;
  float: left;
}

.three_li li:nth-child(2),
.three_li li:nth-child(4),
.three_li li:nth-child(6),
.three_li li:nth-child(8) {
  width: 82px;
  margin-top: 64px;
}

.three_li p {
  font-size: 20px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin-top: 22px;
}

.floor {
  width: 100%;
  height: 553px;
  background: #0a1633;
  overflow: hidden;
}

.floor_1 {
  width: 1200px;
  margin: 0 auto;
  margin-bottom: 54px;
}

.floor_top {
  width: 100%;
  height: 207px;
  border-bottom: 1px solid #263758;
}

.floor_top p:nth-child(2) {
  text-align: center;
}

.shses {
  width: 140px;
  height: 44px;
}

.floor_left {
  width: 600px;
  color: #9ba5b4;
  font-size: 14px;
  float: left;
}

.floor_2 {
  width: 1200px;
  margin: 0 auto;
}

.floor_img {
  margin-bottom: 30px;
}

.floor_left_1 {
  line-height: 30px;
  margin-bottom: 30px;
}

.floor_left_2 p {
  float: left;
  line-height: 22px;
}

.floor_left_2 p img {
  margin: 0 5px;
}

.floor_right {
  width: 600px;
  float: right;
  color: #9ba5b4;
}

.floor_right_1 {
  float: left;
  margin-right: 80px;
}

.floor_right_1:nth-child(3) {
  margin-right: 0;
}

.floor_right_p {
  width: 189px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_p1 {
  width: 120px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_p2 {
  width: 120px;
  height: 30px;
  border-bottom: 1px solid #263758;
  font-size: 14px;
  margin-bottom: 20px;
}

.floor_right_ul1 {
  font-size: 12px;
  float: left;
  margin-right: 39px;
}

.floor_right_ul1 li {
  margin-bottom: 10px;
  cursor: pointer;
}

.floor_right_ul2 {
  font-size: 12px;
}

.floor_right_ul2 li {
  margin-bottom: 10px;
  cursor: pointer;
}

.floor_right_ul2 li:hover {
  color: #fff;
}

.floor_right_ul1 li:hover {
  color: #fff;
}

.floor_onep {
  text-align: center;
  font-size: 34px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  margin: 60px 0 40px 0;
}

.products,
.productsa {
  position: relative;
}

.product {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.product_s {
  width: 558px;
  height: 192.3px;
  margin-left: -260px;
}

.products:hover .product {
  display: block;
}

.product-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.product-div {
  width: 558px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.product-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.product-div_p img {
  margin: 20px;
}

.product-div ul {
  width: 346px;
  height: 80px;
  float: left;
}

.product-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}

.producta {
  width: 100%;
  position: absolute;
  display: none;
  left: 0;
  z-index: 99;
}

.producta_s {
  width: 450px;
  height: 192.3px;
  margin-left: -190px;
}

.productsa:hover .producta {
  display: block;
}

.producta-p {
  width: 21px;
  height: 10px;
  margin: 0 auto;
  line-height: 0;
}

.producta-div {
  width: 450px;
  height: 182.3px;
  background: #fff;
  box-shadow: 0px 0px 10px 0px rgba(225, 230, 240, 1);
  border-radius: 10px;
}

.producta-div_p {
  width: 212px;
  height: 182.3px;
  background: #f1f4f8;
  border-radius: 10px 0px 0px 10px;
  float: left;
}

.producta-div_p img {
  margin: 20px;
}

.producta-div ul {
  width: 238px;
  height: 80px;
  float: left;
  margin-top: 26px;
}

.producta-div ul li {
  margin-left: 38px;
  color: #666666;
  margin-top: 45px;
  line-height: 0;
  font-size: 14px;
  margin-right: 0;
}
</style>



// WEBPACK FOOTER //
// src/view/solve/solve.vue